import * as React from 'react'
import Helmet from 'react-helmet'

// Sitecore's VisitorIdentification.js looks for a VirtualFolder meta tag in order to properly construct links
export const VirtualFolder = () => (
  <Helmet>
    <meta name="VirtualFolder" content="/" />
  </Helmet>
)
